var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRemoveMusic(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 23,
    viewBox: "0 0 22 23",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.8333 9.42204H2.75V11.2554H12.8333V9.42204ZM12.8333 5.75537H2.75V7.5887H12.8333V5.75537ZM2.75 14.922H9.16667V13.0887H2.75V14.922ZM13.2092 20.422L15.5833 18.0479L17.9575 20.422L19.25 19.1295L16.8758 16.7554L19.25 14.3812L17.9575 13.0887L15.5833 15.4629L13.2092 13.0887L11.9167 14.3812L14.2908 16.7554L11.9167 19.1295L13.2092 20.422Z",
    fill: "#AFB6B2"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRemoveMusic);
export default __webpack_public_path__ + "static/media/remove-music.f32432af8893a1c3c9e3154cc46e3109.svg";
export { ForwardRef as ReactComponent };